import { get } from 'lodash'

const COUNTRIES_EXCHANGES = {
  AR: ['BA'],
  AT: ['VI'],
  AU: ['AU'],
  BE: ['BR'],
  BR: ['SA'],
  CA: ['TO', 'V', 'NEO', 'CN'],
  CH: ['SW'],
  CL: ['SN'],
  CN: ['SHG'],
  CZ: ['PR'],
  DE: ['XETRA', 'F', 'STU', 'DU', 'MU', 'HM'],
  DK: ['CO'],
  ES: ['MC'],
  FI: ['HE'],
  FR: ['PA'],
  GB: ['LSE'],
  GR: ['AT'],
  HU: ['BUD'],
  HR: ['ZSE'],
  HK: ['HK'],
  IE: ['IR'],
  IL: ['TA'],
  IT: ['MI'],
  KR: ['KO'],
  JP: ['TYO'],
  LU: ['LU'],
  MX: ['MX'],
  NL: ['AS'],
  NO: ['OL'],
  PE: ['LIM'],
  PL: ['WAR'],
  PT: ['LS'],
  RO: ['RO'],
  RU: ['MCX'],
  SE: ['ST'],
  SG: ['SG'],
  TW: ['TW', 'TWO'],
  US: ['NYSE', 'NASDAQ'],
}

export function getExchangesFromCountry(country) {
  try {
    return get(COUNTRIES_EXCHANGES, country, [])
  } catch (error) {
    throw new Error(error)
  }
}
